/**
 * Common plain text file extensions
 */
export const TEXT_FILE_EXTENSIONS: string[] = [
  // General
  '.txt',

  // Programming Languages
  '.js',
  '.ts',
  '.jsx',
  '.tsx',
  '.mjs',
  '.cjs',
  '.py',
  '.pyw',
  '.pyi',
  '.java',
  '.c',
  '.cpp',
  '.cc',
  '.cxx',
  '.h',
  '.hpp',
  '.hxx',
  '.cs',
  '.go',
  '.rs',
  '.rb',
  '.rake',
  '.php',
  '.swift',
  '.kt',
  '.kts',
  '.scala',
  '.lua',
  '.pl',
  '.pm',
  '.r',
  '.R',
  '.m',
  '.mm',
  '.asm',
  '.s',
  '.sql',
  '.sh',
  '.bash',
  '.zsh',
  '.fish',
  '.ps1',
  '.psm1',
  '.bat',
  '.cmd',
  '.vb',
  '.vbs',
  '.dart',
  '.elm',
  '.ex',
  '.exs',
  '.erl',
  '.hrl',
  '.clj',
  '.cljs',
  '.cljc',
  '.edn',
  '.lisp',
  '.lsp',
  '.cl',
  '.scm',
  '.ss',
  '.hs',
  '.lhs',
  '.ml',
  '.mli',
  '.fs',
  '.fsi',
  '.fsx',
  '.v',
  '.sv',
  '.vhd',
  '.vhdl',
  '.sol',
  '.zig',
  '.nim',
  '.jl',
  '.groovy',
  '.gradle',
  '.coffee',

  // Web Development
  '.css',
  '.scss',
  '.sass',
  '.less',
  '.styl',
  '.vue',
  '.svelte',
  '.astro',
  '.wxss',
  '.wxs',

  // Data & Configuration
  '.json',
  '.jsonc',
  '.json5',
  '.xml',
  '.yaml',
  '.yml',
  '.toml',
  '.ini',
  '.cfg',
  '.conf',
  '.config',
  '.properties',
  '.env',
  '.csv',
  '.tsv',
  '.plist',

  // Documentation & Markup
  '.md',
  '.markdown',
  '.mdown',
  '.mkd',
  '.rst',
  '.adoc',
  '.asciidoc',
  '.tex',
  '.latex',
  '.ltx',
  '.bib',
  '.org',
  '.wiki',
  '.textile',

  // Project & Package Management
  '.gitignore',
  '.gitattributes',
  '.gitmodules',
  '.dockerignore',
  '.npmrc',
  '.nvmrc',
  '.yarnrc',
  '.editorconfig',
  '.prettierrc',
  '.prettierignore',
  '.eslintrc',
  '.eslintignore',
  '.babelrc',
  '.browserslistrc',
  '.stylelintrc',

  // Template Files
  '.ejs',
  '.pug',
  '.jade',
  '.hbs',
  '.handlebars',
  '.mustache',
  '.twig',
  '.jinja',
  '.jinja2',
  '.j2',
  '.erb',
  '.liquid',
  '.njk',

  // Log & System
  '.log',
  '.out',
  '.err',
  '.pid',

  // Other Common Text Files
  '.htaccess',
  '.htpasswd',
  '.ics',
  '.vcf',
  '.vcard',
  '.sub',
  '.srt',
  '.ass',
  '.vtt',
  '.m3u',
  '.m3u8',
  '.pls',
  '.pem',
  '.crt',
  '.key',
  '.csr',
  '.pub',
  '.asc',
  '.gpg',
  '.diff',
  '.patch',
  '.po',
  '.pot',
  '.svg',
  '.graphql',
  '.gql',
  '.proto',
  '.tf',
  '.tfvars',
  '.prisma',
];

/**
 * Check if a file extension is a known text file type
 */
export function isTextFile(filename: string): boolean {
  const ext = filename.toLowerCase().match(/\.[^.]+$/)?.[0];
  if (!ext) return false;
  return TEXT_FILE_EXTENSIONS.includes(ext);
}

export default TEXT_FILE_EXTENSIONS;
